(function(wnd) {
    function EventFilter(container, params) {
        try {
            if (!container || !container.length) {
                throw('container is required');
            }

            this.container = container;
            if (params) {
                this.setParams(params);
            }

            this.init();
        } catch (error) {
            console.error(error);
        }
    }

    EventFilter.prototype = {
        filtering: false,
        listType: undefined,
        listSelector: undefined,
        listContainer: undefined,
        rangeField: undefined,
        init: function () {
            if (!this.listSelector) {
                throw 'List selector is required!';
            }

            this.setElements();
            if (!this.listContainer.length) {
                throw 'Event list not found!';
            }

            this.initDateRangePicker();
            this.addDOMEvents();
        },
        setElements: function () {
            this.listContainer = $(this.listSelector);
            this.dateRangeField = $('#dateRangeField');
        },
        addDOMEvents: function () {
            var _self = this;
            
            this.container.find('input').on('change', function () {
                if ($(this).hasClass('date-range-field')) {
                    return;
                }

                _self.sendForm({
                    type: 'mobile',
                    option: $(this).val(),
                });
            });
        },
        initDateRangePicker: function () {
            var _self = this;
            var today = new Date();
            var params = {
                alwaysShowCalendars: true,
                minDate: today,
                opens: 'center',
                buttonClasses: 'small',
                applyButtonClasses: 'secondary',
                showCustomRangeLabel: false,
            }

            if (typeof dateRangePickerConfig !== 'undefined') {
                params.locale = dateRangePickerConfig.locale;
            }

            if (typeof dateRangePickerConfig.ranges !== 'undefined') {
                params.ranges = {};

                $.each(dateRangePickerConfig.ranges, function(key, label) {
                    var start = null;
                    var end = null;
                    switch (key) {
                        case 'today':
                            start = moment();
                            end = moment();
                            break;
                        case 'this_week':
                            start = moment().startOf('isoWeek');
                            end = moment().endOf('isoWeek');
                            break;
                        case 'this_month':
                            start = moment().startOf('month');
                            end = moment().endOf('month')
                            break;
                    }
                    
                    params.ranges[label] = [start, end]
                })
            }

            this.dateRangeField.daterangepicker(params, function (start, end, label) {
                _self.sendForm({
                    type: 'desktop',
                    start: start.format('YYYY-MM-DD'),
                    end: end.format('YYYY-MM-DD'),
                });
            });
        },
        setParams: function (params) {
            if (params.listType) this.setListType(params.listType);
            if (params.listSelector) this.setListSelector(params.listSelector);
        },
        sendForm: function (data) {
            var _self = this;
            if (this.filtering) {
                return;
            }

            data.layout = this.listType;

            this.filtering = true;
            $.ajax({
                url: _self.container.attr('action'),
                dataType: 'json',
                type: 'post',
                data: data,
                success: function (response) {
                    _self.updateEvents(response.html);
                },
                complete: function () {
                    setTimeout(function(){
                        _self.filtering = false;
                    }, 300);
                }
            })
        },
        updateEvents: function(html) {
            this.listContainer.html(html);
            console.log(this.listType);
            switch (this.listType) {
                case 'slider':
                case 'swiper':
                    console.log('itten');
                    $(document).trigger('pwstudio.event_list_updated');
                    break;
            }
        },
        setListType: function (listType) {
            this.listType = listType;
        },
        setListSelector: function (listSelector) {
            this.listSelector = listSelector;
        }
    }

    wnd.EventFilter = EventFilter;
})(window);